// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-SgvW","importantInfo":"styles_importantInfo__2olCY"};